<template>
    <el-drawer :title="dialog.title" :type="dialog.type" :visible.sync="drawer" :modal="false" :before-close="closeDrawer">
        <div class="drawer-form">
            <el-form ref="form" :model="ruleForm" label-width="80px">
                <el-form-item label="类型" prop="parent_id">
                    <el-select v-model="ruleForm.parent_id" placeholder="请选择类型" clearable>
                        <el-option v-for="(item, index) in parents" :key="index" :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分类标题" prop="title">
                    <el-input v-model="ruleForm.title" placeholder="请填写分类"></el-input>
                </el-form-item>
                <el-form-item label="单位" prop="unit">
                    <el-input v-model="ruleForm.unit" placeholder="请填写提示信息"></el-input>
                </el-form-item>
                <el-form-item label="提示信息" prop="tip">
                    <el-input v-model="ruleForm.tip" placeholder="请填写提示信息"></el-input>
                </el-form-item>
                <el-form-item label="应用场景" prop="zone">
                    <el-select v-model="ruleForm.zone" placeholder="请选择应用场景" clearable>
                        <el-option label="全部" value="all"></el-option>
                        <el-option label="工程外发" value="control_project"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="ruleForm.sort"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit">保存</el-button>
                    <el-button @click="closeDrawer">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-drawer>
</template>

<script>
// 初始参数
const ruleForm = {
    id: "",
    parent_id: "",
    title: "",
    unit: "",
    tip: "",
    role: "",
    zone: "all",
    sort: 0
};
export default {
    props: {
        parents: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            url: '',
            drawer: false,
            ruleForm: Object.assign({}, ruleForm),
            dialog: {
                title: '',
            },
        };
    },
    methods: {
        showDrawer(type, row, role) {
            console.log(type, row, role)
            this.ruleForm = Object.assign({}, ruleForm);
            this.ruleForm.role = role;
            if (type == 'add') {
                this.dialog.title = '添加供应商分类';
                this.dialog.type = 'add';
                this.url = '/api/supplier.category/create';
            } else {
                this.dialog.type = 'edit'
                this.dialog.title = '编辑供应商分类';
                this.ruleForm.id = row.id;
                this.ruleForm.parent_id = row.parent_id > 0 ? row.parent_id + '' : '';
                this.ruleForm.title = row.title;
                this.ruleForm.tip = row.tip;
                this.ruleForm.unit = row.unit;
                this.ruleForm.sort = row.sort;
                this.url = '/api/supplier.category/save';
            }
            this.drawer = true;
        },
        submit() {
            let _this = this;
            if (!this.ruleForm.title) {
                _this.$message.warning('请填写分类标题');
                return false
            }

            this.$post(this.url, this.ruleForm).then(res => {
                if (res.code == '200') {
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    _this.$emit('getTableData');
                    _this.$emit('getParents');
                    _this.drawer = false;
                }
            })
        },
        // 清空筛选项
        reset() {
            this.ruleForm = Object.assign({}, ruleForm);
        },
        //关闭页面 清空已添加的数据
        closeDrawer() {
            this.$refs['form'].resetFields();
            this.category = false;
            this.drawer = false;
        },
    }
}
</script>
